export const DEVICE_STATUS_DISPLAY_NAME = {
  MONO_MDM_LOCKED: 'MDM',
  MONO_ACTIVATION_LOCKED: 'Activation',
  MONO_RECOVERY_LOCKED: 'Recovery',
};
